module.exports = __webpack_public_path__ + "static/img/256_TO8_2316.6406b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/256_TO8_2316.jpg
// module id = gT00
// module chunks = 0